import React from "react";
import Hero from "../components/Hero";
import MarketTicker from "../components/MarketTicker";
import WhyXpo from "../components/WhyXpo";
import PlatformPreview from "../components/PlatformPreview";
import AccountTypes from "../components/AccountTypes";
import StatsBand from "../components/StatsBand";
import BlogPreview from "../components/BlogPreview";
import BottomCTA from "../components/BottomCTA";
import { useBlogs } from "../hooks/useBlogs";

export default function HomePage() {
    const { posts } = useBlogs();

    return (
        <div data-testid="home-page">
            <Hero />
            <MarketTicker />
            <WhyXpo />
            <StatsBand />
            <PlatformPreview />
            <AccountTypes />
            <BlogPreview posts={posts} />
            <BottomCTA />
        </div>
    );
}
